import { GroupePiecesDto, SearchPieceDto } from '@/shared/services/service-clients'
import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-item-group',
  imports: [CommonModule, MatIconModule],
  templateUrl: './item-group.component.html',
  styleUrls: ['./item-group.component.scss'],
})
export class ItemGroupComponent {
  @Input()
  selected!: boolean

  @Input()
  baliseName!: string

  @Input()
  groupPiece!: SearchPieceDto[]

  @Input()
  PieceNotSearch!: SearchPieceDto[]

  constructor() {
  }
}
